module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container page Hpercent"
  }, [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("\n\t\t\t分类\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "menu-box"
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.tabs), function(item, index) {
    return _c('li', [_c('router-link', {
      class: {
        'active': index === _vm.tabIndex
      },
      attrs: {
        "to": item.name
      }
    }, [_c('span', [_vm._v(_vm._s(item.label))])])], 1)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "list-box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabIndex === 0),
      expression: "tabIndex === 0"
    }],
    staticClass: "menu-list-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/build.png"),
      "alt": ""
    }
  }), _vm._v("\n          云服务器正在建设中...\n        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabIndex === 1),
      expression: "tabIndex === 1"
    }],
    staticClass: "menu-list-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/build.png"),
      "alt": ""
    }
  }), _vm._v("\n          虚拟主机正在建设中...\n        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabIndex === 2),
      expression: "tabIndex === 2"
    }],
    staticClass: "menu-list-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/build.png"),
      "alt": ""
    }
  }), _vm._v("\n          域名功能正在建设中...\n        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabIndex === 3),
      expression: "tabIndex === 3"
    }],
    staticClass: "menu-list-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/build.png"),
      "alt": ""
    }
  }), _vm._v("\n          免费空间正在建设中...\n        ")])])]), _vm._v(" "), _c('c-footer', {
    attrs: {
      "status": "product"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46ab7c13","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/menu.vue
// module id = TY9s
// module chunks = 1